import { XCircle } from "lucide-react";
import { BaseAppointmentAction, AppointmentActionCategory, UserRole, AppointmentActionContext, AppointmentActionPayload, AppointmentActionResult } from "../core/base-action";
import { appointment_status } from "@/models/appointment.model";
import { AppointmentApprovalService } from "@/services/appointment-approval.service";
import { NO_CANCELLATION_REASON_GIVEN } from "@/lib/appointment-cancellation";

export class CancelRequestAction extends BaseAppointmentAction {
    readonly config = {
        id: "cancel_request",
        label: "Request Cancellation",
        description: "Request appointment cancellation from PMC",
        icon: XCircle,
        category: AppointmentActionCategory.REQUEST,
        permissions: {
            requiredRole: [UserRole.VENDOR],
            excludedStatuses: [appointment_status.done, appointment_status.completed, appointment_status.cancelled]
        },
        requiresDialog: true,
        variant: "destructive" as const
    };

    validatePayload(payload?: AppointmentActionPayload): string | null {
        // Reason is optional for cancellation requests
        return null;
    }

    getDialogComponent(): string {
        return "CancelRequestDialog";
    }

    async execute(
        context: AppointmentActionContext,
        payload?: AppointmentActionPayload
    ): Promise<AppointmentActionResult> {
        try {
            const { reason, roomId } = payload || {};
            
            if (!roomId) {
                throw new Error("Room ID is required for approval requests");
            }

            await AppointmentApprovalService.sendApprovalRequest(roomId, { type: "cancel", reason: reason || NO_CANCELLATION_REASON_GIVEN });

            return {
                success: true,
                message: "Cancellation request sent to PMC for approval"
            };
        } catch (error: any) {
            return {
                success: false,
                message: error.message || "Failed to send cancellation request"
            };
        }
    }
}